/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Pretty_Canary_ExpressInputs */

const fr_plain_pretty_canary_express = /** @type {(inputs: Plain_Pretty_Canary_ExpressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dois mettre de chaque côté :`)
};

/**

* @param {Plain_Pretty_Canary_ExpressInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plain_pretty_canary_express = /** @type {((inputs?: Plain_Pretty_Canary_ExpressInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Pretty_Canary_ExpressInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plain_pretty_canary_express(inputs)
});